import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { EntitypagelayoutApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
/*
This custom field is used to select global pagelayouts for an app.
*/

@Component({
  selector: 'formly-pagelayout-selector',
  template: `
   <ng-select *ngIf="items.length > 0"   
              [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)"
              [items]="items"
              [multiple]="false"
               [disabled]="to.disabled"
              placeholder=""
              [allowClear]="!to.required" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
  providers: [EntitypagelayoutApi]
})
export class PagelayoutSelect extends FieldType implements OnInit, OnDestroy {
  _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
  items: any = [];
  selectedvalues: any = [];
  currentuser;
  appId;
  constructor(private _EntitypagelayoutApi: EntitypagelayoutApi, private _LoopBackAuth: LoopBackAuth, private _PlatformApp: PlatformApp) {
    super();
  }

  ngOnInit() {
    if (!this.form['subscriptions'])
      this.form['subscriptions'] = [];

    // Adding new Controls to hold formControls for hidden fields
    if (!this.form['newcontrols'])
      this.form['newcontrols'] = {};
    for (var key in this.form.controls) {
      this.form['newcontrols'][key] = this.form.controls[key];
    }

    this.currentuser = this._LoopBackAuth.getCurrentUserData();
    if (PlatformApp.getAppVariable("platformApp")) {
      this.appId = PlatformApp.getAppVariable("referenceAppId");

    } else {
      this.appId = this.currentuser.appId
    }
    //1) Load the drop down values    

    //1) Load the drop down values    
    this._loopbackfilter.where = { 'appId': this.appId };
    //Hack - Get the app id from the model itself.
    //Get the pagelayouts for the App
    this._EntitypagelayoutApi.find(this._loopbackfilter).subscribe((pagelayouts) => {
      if (pagelayouts) {
        for (var i = 0; i < pagelayouts.length; i++) {
          if (this.model.id !== pagelayouts[i]["id"]) {
            this.items.push({ id: pagelayouts[i]["id"], text: pagelayouts[i]["name"] })
          }

          if (this.model[this.key] && this.model[this.key].indexOf(pagelayouts[i]["id"]) > -1) {
            this.selectedvalues = [{ id: pagelayouts[i]["id"], text: pagelayouts[i]["name"] }];
          }
        }
        //Sort the values
        this.items = _.sortBy(this.items, 'text');
      }
    });

  }

  ngOnDestroy() {
    this.selectedvalues = "";
  }

  private value: any = {};


  public selected(value: any): void {
    if (value && value.id)
      this.formControl.setValue(value.id);

    for (var key in this.form['newcontrols'])
      this.form.setControl(key, this.form['newcontrols'][key]);
  }

  public removed(value: any): void {
    if (value && value.id)
      if (this.model[this.key] && this.model[this.key].length)
        this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
  }

  public typed(value: any): void {

  }

  public refreshValue(value: any): void {
    this.value = value;
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectpagelayout.ts